import React, { useState } from "react";

//components material mui
import {
    Button,
    DialogContent,
    DialogActions,
    Typography,
    Box,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

//components
import { DialogoBoostrap } from "../../ControlUsuario/DialogoPersonalizado/DialogoBoostrap";

//hooks
import { useGlobalState } from "../../../Utilidades/useGlobalState";

let funcionAbrirModal;
let validaAbrirModal;

/**
 * Modal "Hubo un problema con tu pago". Se muestra al volver de la pasarela
 * cuando la validación en backend (validarPagoInvoice) indica que el pago no se
 * concilió. La admisión y el invoice quedan intactos para reintentar. El botón
 * "Salir" solo cierra el modal (no redirige a ningún sitio).
 */
export const DialogoPagoFallido = () => {
    const { etiquetas } = useGlobalState();

    const [abierto, setAbierto] = useState(false);
    funcionAbrirModal = setAbierto;
    validaAbrirModal = abierto;

    const lbl = etiquetas?.PagoEnLinea || {};

    return (
        <DialogoBoostrap
            open={abierto}
            onClose={() => setAbierto(false)}
            maxWidth="xs"
            fullWidth
        >
            <DialogContent style={{ textAlign: "center", padding: "24px" }}>
                <Box style={{ display: "inline-flex", marginBottom: 12 }}>
                    <ErrorOutlineIcon style={{ color: "#C62828", fontSize: 48 }} />
                </Box>
                <Typography style={{ fontWeight: 700, fontSize: 18, marginBottom: 8, color: "#C62828" }}>
                    {lbl.Et_TituloPagoFallido || "Hubo un problema con tu pago"}
                </Typography>
                <Typography style={{ fontSize: 14, color: "#3F425D", marginBottom: 8 }}>
                    {lbl.Et_DescripcionPagoFallido ||
                        "No pudimos confirmar tu pago. No se realizó ningún cobro o el proceso quedó incompleto. Puedes intentarlo nuevamente desde el portal de estudiantes."}
                </Typography>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center", padding: "8px 24px 20px" }}>
                <Button
                    fullWidth
                    variant="contained"
                    style={{ backgroundColor: "#082375", color: "#FFFFFF" }}
                    onClick={() => setAbierto(false)}
                >
                    {lbl.Et_Salir || "Salir"}
                </Button>
            </DialogActions>
        </DialogoBoostrap>
    );
};

export const mostrarDialogoPagoFallido = () => {
    funcionAbrirModal(!validaAbrirModal);
};
